import * as Turbo from '@hotwired/turbo'
import cookieConsentModal from './js/cookie_consent_modal.js'
import script from './js/script.js'

Turbo.start()
document.addEventListener("turbo:load", cookieConsentModal);
document.addEventListener("turbo:load", script);
document.addEventListener("turbo:visit", script);
